import type { Template, TunaPlugin } from '@tunasong/plugin-lib'

/**
 * Whether the create dialog should show a Configure step.
 *
 * The plugin decides whether configuration is *possible* (it declares a schema
 * or a CreateEntity component); the selected template can opt out of it. A
 * plugin may expose several templates where only some need a form — the song
 * plugin's blank `Song` has nothing to configure while `Cover song` does.
 */
export const canConfigureEntity = (plugin?: TunaPlugin, template?: Template) => {
  if (template?.skipConfiguration) {
    return false
  }
  return Boolean(plugin?.schema || plugin?.components?.CreateEntity)
}
